var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nav"},[_c('div',{staticClass:"menu"},[_c('div',{staticClass:"gaibian",on:{"click":_vm.handleBackHome}},[_c('span',[_vm._v(_vm._s(_vm.$t('common.home')))])]),_c('div',{staticClass:"moren"},[_vm._v(" "+_vm._s(_vm.$t('common.Enterprise_settlement'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }